import { render, staticRenderFns } from "./classificacao.vue?vue&type=template&id=16c1ba67"
import script from "./classificacao.vue?vue&type=script&lang=js"
export * from "./classificacao.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports